import { LanguagesCode } from 'src/i18n/constants';

const flagsBaseUrl = 'https://assets.vitastudent.com/dist';

export const flagOptions = [
    {
        code: LanguagesCode.English,
        label: 'ENGLISH',
        iconSrc: `${flagsBaseUrl}/1629897461555/english-flag.jpg`,
    },
    {
        code: LanguagesCode.Spanish,
        label: 'ESPAÑOL',
        iconSrc: `${flagsBaseUrl}/1629900952449/spanish-flag.jpg`,
    },
];
